import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "specialPageCarousel__soloImg"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "specialPageCarousel__slider" }
const _hoisted_5 = { class: "specialPageCarousel__sliderBody" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "specialPageCarousel__more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_AppCarousel2 = _resolveComponent("AppCarousel2")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_TextButton = _resolveComponent("TextButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.specialPageCarouselClass)
  }, [
    (_ctx.carouselData.length === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselData, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.id,
              href: `/specialPage/detail/?spid=${item.alias}`
            }, [
              _createElementVNode("img", {
                src: item.url,
                alt: item.alt
              }, null, 8, _hoisted_3)
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : (_ctx.carouselData.length > 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AppCarousel2, { mergeOptions: _ctx.carouselMergeOptions }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselData, (item) => {
                      return (_openBlock(), _createBlock(_component_SwiperSlide, {
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: `/specialPage/detail/?spid=${item.alias}`
                          }, [
                            _createElementVNode("img", {
                              class: "object-fit h-max-40",
                              src: item.url,
                              alt: item.alt
                            }, null, 8, _hoisted_7)
                          ], 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["mergeOptions"])
              ])
            ]),
            (_ctx.showMore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_TextButton, {
                    to: "/specialPage",
                    position: "right"
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createTextVNode(" もっと見る", -1)),
                      _createVNode(_component_Icon, {
                        name: "arrow_right",
                        color: _ctx.colorCode
                      }, null, 8, ["color"])
                    ]),
                    _: 1,
                    __: [0]
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}